import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { SystemLayoutComponent } from "../../shared/components/layouts/system-layout/system-layout";
import { SystemTourComponent } from "../../shared/components/system-tour/system-tour";

/**
 * @docs - Authenticated Page
 *
 * This is a utility component class whose purpose is to
 * represent a page that requires the user to be authenticated.
 * It also able to redirect users to either the "/console" or "/dashboard"
 *
 * !note No extraneous logic is required here nor expected hence the lack of a unit test
 */
@Component({
  template: `<adaa-system-layout> <router-outlet></router-outlet> </adaa-system-layout> <adaa-system-tour />`,
  imports: [RouterOutlet, SystemLayoutComponent, SystemTourComponent],
})
export class AuthenticatedPage {}
